var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-container',[_c('div',{staticClass:"not-available"},[_c('p',[_vm._v(_vm._s(_vm.displayedMessage))]),_c('p',[_vm._v("¯\\_(ツ)_/¯")])]),_c('page-contact-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }